import { render, staticRenderFns } from "./text-row-disagreement-table.vue?vue&type=template&id=2f23bb8f&"
import script from "./text-row-disagreement-table.vue?vue&type=script&lang=js&"
export * from "./text-row-disagreement-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f23bb8f')) {
      api.createRecord('2f23bb8f', component.options)
    } else {
      api.reload('2f23bb8f', component.options)
    }
    module.hot.accept("./text-row-disagreement-table.vue?vue&type=template&id=2f23bb8f&", function () {
      api.rerender('2f23bb8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/text-row-disagreement-table.vue"
export default component.exports